<template>
  <div class="big benevolenceValue">
    <!-- 从excel导入 -->
    <import-excel
      :isFlag="isImport"
      interfaceName="importDoctorHeartAccountDetail"
      :paramsObj="{}"
      :isConfirm="true"
      :tableHeader="importTableHeader"
      confirmInterfaceName="confirmDoctorHeartAccountDetail"
      paramsKey="heart_pic"
      temName="heart_pic"
      @refreshList="getList"
    ></import-excel>
    <div class="page_title">医生仁心值记录</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container" style="padding: 10px 20px 20px 20px">
        <div class="search-box">
          <!-- 医生姓名 -->
          <div class="item">
            <span>医生姓名</span>
            <div class="item-content">
              <el-input
                v-model="benevolenceForm.doctor_name"
                size="small"
                clearable
                style="width: 150px"
                @keyup.enter.native="seachEnterFun"
                placeholder="医生"
              ></el-input>
            </div>
          </div>

          <!-- 医生手机号 -->
          <div class="item">
            <span style="margin-left: 10px">医生手机号</span>
            <div class="item-content">
              <el-input
                v-model="benevolenceForm.phone"
                size="small"
                clearable
                @keyup.enter.native="seachEnterFun"
                placeholder="医生手机号"
              ></el-input>
            </div>
          </div>

          <!-- 仁心值 -->
          <div class="item">
            <span style="margin-left: 10px">仁心值</span>
            <div class="item-content">
              <el-input-number
                v-model="benevolenceForm.heart_num_start"
                :min="0"
                :max="999999"
                :precision="0"
                :controls="false"
                size="small"
                placeholder="请输入数字"
                @keyup.enter.native="seachEnterFun"
              ></el-input-number>
              <span>-</span>
              <el-input-number
                v-model="benevolenceForm.heart_num_end"
                :min="0"
                :max="999999"
                :precision="0"
                :controls="false"
                size="small"
                placeholder="请输入数字"
                @keyup.enter.native="seachEnterFun"
              ></el-input-number>
            </div>
          </div>

          <!-- 按时间查询 -->
          <div class="item">
            <span style="margin-left: 10px">按时间查询</span>
            <el-tooltip
              effect="light"
              content="筛选结果为该时间段内有仁心值变动的医生数据"
              placement="top"
            >
              <el-button type="text" icon="el-icon-question"></el-button>
            </el-tooltip>
            <div class="item-content">
              <el-date-picker
                v-model="benevolenceForm.dateTime"
                type="daterange"
                align="right"
                size="small"
                unlink-panels
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="getList"
              >
              </el-date-picker>
            </div>
            <el-button
              type="primary"
              size="small"
              style="margin-left: 20px"
              @click="getList"
              >查询</el-button
            >
            <el-button size="small" @click="restBtn">重置</el-button>
            <el-button
              type="primary"
              size="small"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1085') : false
              "
              @click="excelImport"
              >导入明细数据</el-button
            >
            <el-button
              type="primary"
              size="small"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1705') : false
              "
              @click="returnDataBtn"
              >三方退还数据</el-button
            >
          </div>
        </div>

        <div class="statistics-card">
          <el-card
            class="box-card"
            v-for="(item, index) in statisticsData"
            :key="index"
          >
            <img :src="item.url" />
            <div class="desc">
              <div class="value">{{ item.value }}</div>
              <div class="title">{{ item.title }}</div>
            </div>
          </el-card>
        </div>

        <div style="border: solid 1px #c9cbd6">
          <el-table
            v-loading="tableLoading"
            :data="benevolenceData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
            @sort-change="sortChange"
          >
            <el-table-column
              v-for="item in tableHeader"
              :key="item.prop"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              :fixed="item.fixed"
              :sortable="item.sortable"
            >
              <template slot-scope="scope">
                <div v-if="item.prop == 'create_time'">
                  {{ scope.row[item.prop] | dateFormat }}
                </div>
                <div v-else>
                  {{
                    JSON.stringify(scope.row[item.prop]) === "null"
                      ? ""
                      : scope.row[item.prop]
                  }}
                </div>
              </template>
            </el-table-column>

            <el-table-column
              label="操作"
              width="120"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="medium"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1082')
                      : false
                  "
                  @click="toDetail(scope.row)"
                  >查看明细</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 分页 -->
        <pagination
          v-show="totalNum > 0"
          :total="totalNum"
          :page.sync="pagination.page"
          :limit.sync="pagination.pageNumber"
          @pagination="getList"
        />
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import dayjs from "dayjs";
import marketing from "@/api/marketing.js";
import Pagination from "@/components/Pagination/index";
import ImportExcel from "@/components/importExcel/index.vue";
export default {
  components: {
    Pagination,
    ImportExcel,
  },
  data() {
    return {
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      benevolenceForm: {
        doctor_name: "",
        phone: "",
        heart_num_start: "",
        heart_num_end: "",
        dateTime: "",
      },
      sortParams: {
        order_key: "",
        order_value: "",
      },
      tableHeader: [
        {
          label: "医生姓名",
          prop: "doctor_name",
          width: "auto",
          align: "center",
          fixed: "left",
          sortable: false,
        },
        {
          label: "手机号",
          prop: "phone",
          width: "auto",
          align: "center",
          fixed: false,
          sortable: false,
        },
        {
          label: "职称",
          prop: "title",
          width: "120",
          align: "center",
          fixed: false,
          sortable: false,
        },
        {
          label: "医院",
          prop: "hospital",
          width: "200",
          align: "center",
          fixed: false,
          sortable: false,
        },
        {
          label: "认证时间",
          prop: "create_time",
          width: "200",
          align: "center",
          fixed: false,
          sortable: false,
        },
        {
          label: "当前仁心值",
          prop: "heart_num",
          width: "140",
          align: "center",
          fixed: false,
          sortable: "custom",
        },
        {
          label: "已用仁心值",
          prop: "use_heart_num",
          width: "auto",
          align: "center",
          fixed: false,
          sortable: "custom",
        },
        {
          label: "失效仁心值",
          prop: "cancel_heart_num",
          width: "auto",
          align: "center",
          fixed: false,
          sortable: "custom",
        },
      ],
      importTableHeader: [
        {
          label: "数据条数",
          prop: "total_num",
          width: "auto",
        },
        {
          label: "医生人数总计",
          prop: "doctor_num",
          width: "120",
        },
        {
          label: "入账仁心值总计",
          prop: "total_heart",
          width: "120",
        },
        {
          label: "消费仁心值总计",
          prop: "total_use_heart",
          width: "120",
        },
        {
          label: "失效仁心值总计",
          prop: "total_cancel_heart",
          width: "120",
        },
      ],
      benevolenceData: [],
      statisticsData: [],
      isImport: false,
      interfaceName: "importTcmTemplate",
      doctor_info: {},
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm");
    },
    preGroupText(val) {
      switch (val) {
        case -1:
          return "成药";
        case 0:
          return "养生膏方";
        case 1:
          return "颗粒";
        case 2:
          return "饮片";
        case 3:
          return "膏方";
        case 4:
          return "丸剂";
      }
    },
    statusText(val) {
      switch (val) {
        case 1:
          return "待取药";
        case 2:
          return "待审方";
        case 3:
          return "已通过";
        case 4:
          return "已抓药";
        case 5:
          return "已失效[过期未取药]";
        case 6:
          return "已失效[审方不通过]";
        case 7:
          return "已失效[医生手动作废]";
        case 8:
          return "已失效[平台退款]";
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      let params = Object.assign(
        this.pagination,
        this.benevolenceForm,
        this.sortParams
      );
      this.tableLoading = true;
      params = _.omit(params, "dateTime");
      params.start_time = this.benevolenceForm.dateTime
        ? this.benevolenceForm.dateTime[0]
        : "";
      params.end_time = this.benevolenceForm.dateTime
        ? this.benevolenceForm.dateTime[1]
        : "";
      marketing.doctorHeartAccountList(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          let { list, count_data, total } = data;
          this.benevolenceData = list;
          this.totalNum = total;
          this.statisticsData = [
            {
              url: require("../../../assets/img/benevolence/current_renxin.png"),
              title: "当前仁心值总计",
              value: count_data.total_heart_num
                ? count_data.total_heart_num
                : 0,
            },
            {
              url: require("../../../assets/img/benevolence/used_renxin.png"),
              title: "已用仁心值总计",
              value: count_data.total_use_heart_num
                ? count_data.total_use_heart_num
                : 0,
            },
            {
              url: require("../../../assets/img/benevolence/failure_renxin.png"),
              title: "失效仁心值总计",
              value: count_data.total_cancel_heart_num
                ? count_data.total_cancel_heart_num
                : 0,
            },
          ];
          this.tableLoading = false;
        }
      });
    },
    sortChange(value) {
      let { order, prop } = value;
      //升序
      if (order == "ascending") {
        this.sortParams.order_value = "asc";
      }
      //降序
      if (order == "descending") {
        this.sortParams.order_value = "desc";
      }
      this.sortParams.order_key = prop;
      if (!order) {
        this.sortParams = {
          order_key: "",
          order_value: "",
        };
      }
      this.getList();
    },
    seachEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.getList();
      }
    },
    toDetail(row) {
      let { doctor_id } = row;
      this.$router.push({
        path: "/home/marketing/benevolenceDetails",
        query: {
          doctor_id,
          changeTime: this.benevolenceForm.dateTime,
        },
      });
    },
    restBtn() {
      for (let key in this.benevolenceForm) {
        if (key == "create_time") {
          this.benevolenceForm[key] = [];
        } else {
          this.benevolenceForm[key] = "";
        }
      }
      this.getList();
    },
    excelImport() {
      this.isImport = !this.isImport;
    },
    // 三方退还数据
    returnDataBtn() {
      this.$router.push({
        path: "/home/marketing/returnData",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.benevolenceValue {
  .search-box {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 10px;
    .item {
      height: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      span {
        display: inline-block;
        margin-right: 4px;
        text-align: right;
        white-space: nowrap;
        box-sizing: border-box;
      }
    }
    .item-content {
      // width: 100%;
      .el-date-editor {
        width: 100%;
      }
    }
  }
  .statistics-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    .box-card {
      width: 30%;
      ::v-deep .el-card__body {
        display: flex;
        align-items: center;
        justify-content: space-around;
        img {
          width: 80px;
          height: 80px;
        }
        .desc {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .value {
            font-size: 20px;
            font-weight: bold;
          }
          .title {
            padding: 10px 0;
          }
        }
      }
    }
  }
}
</style>
